import StudentClassroomAPI from '@/apis/business/teacher/student-classroom-api.js'
import StudentAPI from '@/apis/business/teacher/student-api.js'
import Enumeration from '@/common/enumeration.js'

export default {
  namespaced: true,
  state: {
    students: [],
    student: {},
    totalStudent: 0,
    totalDataStudent: {},
    isEnableRemoveStudent: false
  },

  getters: {

    getStudent (state) {
      return state.student
    }
  },

  mutations: {

    setEnableRemoveStudent (state, status) {
      state.isEnableRemoveStudent = status
    },

    /**
     * Tính toán cho state totalStudent trong lớp học
     * @param {*} state
     * @param {*} totalStudent
     */
    setTotalStudent (state, totalStudent) {
      state.totalStudent += totalStudent
    },

    /**
     * set giá trị cho state totalStudent
     * @param {*} state
     * @param {*} totalStudent
     */
    setDefaultTotalStudent (state, totalStudent) {
      state.totalStudent = totalStudent
    },

    /**
     * @description set dữ liệu cho state classrooms
     * @author NTQyy
     * @param {*} state
     * @param {*} classRooms
     */
    setStudents (state, students) {
      state.students = students
    },

    /**
     * Set dữ liệu cho state student
     * @param {*} state
     * @param {*} student
     */
    setStudent (state, student) {
      state.student = student
    },

    /**
     * @description Cập nhật lại trạng thái của students trong state
     * @author NTQuy
     * @param {*} state
     * @param {*} student
     */
    updateApproveStatusStudent (state, student) {
      const index = state.students.findIndex(item =>
        item.Id === student.Id
      )

      state.students[index].ApproveStatus = student.ApproveStatus
    },

    /**
   * @description Cập nhật tất cả trạng thái của học sinh từ pending
   * @param {*} state
   */
    updateStatusAllStudent (state) {
      state.students.forEach(student => {
        student.ApproveStatus = Enumeration.StudentApproveStatus.Approve
      })
    },

    /**
     * @description Xóa 1 item trong state students
     * @author NTQuy
     * @param {*} state
     * @param {*} student
     */
    deleteStudent (state, id) {
      const index = state.students.findIndex(item => item.Id === id)

      state.students.splice(index, 1)
    }

  },

  actions: {

    /**
     * Đổi mật khẩu mặc định cho học sinh
     * @param {} context
     * @param {*} param
     * @returns
     */
    resetPasswordStudent (context, studentID) {
      const query =
      `studentID=${studentID}`
      return new Promise((resolve, reject) => {
        StudentAPI.getAsync(`reset-password?${query}`).then(res => {
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Load toàn bộ học sinh màn hình overview
     * @param {*} context
     * @author NVHUY1
     */
    getStudentsOverview (context, param) {
      const query =
        `classCode=${param.ClassCode ? param.ClassCode : ''}` +
        `&date=${param.Date}` +
        `&sortType=${param.SortType}`
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getAsync(`overview?${query}`).then(res => {
          context.commit('setStudents', res.Data)
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Load toàn bộ học sinh trong lớp từ API
     * @param {*} context
     * @author NTQuy
     */
    getStudents (context, param) {
      const query =
        `classCode=${param.ClassCode ? param.ClassCode : ''}` +
        `&classID=${param.ClassID ? param.ClassID : ''}` +
        `&takeAll=${param.takeAll ? param.takeAll : ''}`
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getAsync(`students?${query}`).then(res => {
          context.commit('setStudents', res.Data)

          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Gọi API lấy dữ liệu của 1 học sinh
     * @param {*} context
     * @param {*} student
     * @returns
     */
    getStudent (context, student) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getStudent(student).then(res => {
          context.commit('setStudent', res.Data)
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Sửa trạng thái của học sinh
     * @author NTQuy
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    updateApproveStatusStudent (context, student) {
      const bodyUpdate = {
        ApproveStatus: student.ApproveStatus,
        SISAPCode: student.SISAPCode,
        StudentID: student.StudentID
      }
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.putAsync(`/student?id=${student.Id}&classCode=${student.ClassCode}`, bodyUpdate).then(
          context.commit('updateApproveStatusStudent', student),
          context.commit('setTotalStudent', 1)
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Sửa trạng thái của tất cả học sinh thành phê duyệt
     * @author NTQuy
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    approveStatusAllStudent (context, params) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.putAsync(`/student/${params.classCode}`, params.total).then(
          context.commit('updateStatusAllStudent'),
          context.commit('setTotalStudent', params.total)
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Gọi API xóa học sinh
     * @author NTQuy
     * @param {*} context
     * @param {*} id
     * @returns
     */
    deleteStudent (context, id) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.deleteStudent(id).then(
          context.commit('deleteStudent', id),
          resolve(true)
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Gọi API gỡ học sinh đồng thời cập nhật lại totalStudent
     * @author NTQuy
     * @param {*} context
     * @param {*} id
     * @returns
     */
    removeStudent (context, student) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.deleteAsync(`student?id=${student.Id}&classCode=${student.ClassCode}`).then(
          context.commit('deleteStudent', student.Id),
          context.commit('setTotalStudent', -1),
          resolve(true)
        ).catch(err => {
          reject(err)
        })
      })
    },
    /**
     * Cập nhật thông tin mã SISAP cho học sinh
     * @param {*} context
     * @param {*} params
     * @returns
     */
    updateStudent (context, params) {
      const bodyUpdate = {
        StudentID: params.StudentID,
        SISAPCode: params.SISAPCode,
        OrganizationID: params.OrganizationID
      }
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.putAsync(`/sisapcode?id=${params.Id}&classCode=${params.ClassCode}`, bodyUpdate).then((res) => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Kiểm tra trùng mã SISAP cho học sinh
     * @param {*} context
     * @param {*} params
     * @returns
     */
    checkSISAPCodeStudent (context, params) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.postAsync(`same-sisap?classID=${params.ClassEMISID}`, params).then((res) => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }

  }
}
